import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20modern%20entertainment%20platform%20background%20with%20abstract%20geometric%20shapes%2C%20warm%20orange%20and%20amber%20gradient%20accents%2C%20flowing%20dynamic%20lines%2C%20digital%20media%20atmosphere%2C%20creative%20energy%2C%20cinematic%20lighting%20with%20soft%20bokeh%2C%20dark%20rich%20background%20with%20warm%20highlights%2C%20professional%20production%20aesthetic&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="快猫视频 - 短视频娱乐平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-sparkling-line text-accent-400 text-sm"></i>
            <span className="text-xs md:text-sm text-background-50/90">全网最受欢迎的短视频娱乐平台</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-6">
            海量精彩短视频
            <br />
            <span className="text-primary-400">即刻开启娱乐之旅</span>
          </h1>

          <p className="text-sm md:text-base text-background-50/75 max-w-xl mx-auto mb-8 leading-relaxed">
            快猫视频汇聚搞笑、生活、才艺、美食等多元内容，AI智能推荐让你越刷越上瘾。支持一键下载、离线观看、好友分享，随时随地畅享短视频乐趣。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#download"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-download-line"></i>
              立即下载快猫视频
            </a>
            <Link
              to="/category/gaoxiao"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-full text-sm border border-background-50/25 hover:bg-background-50/20 transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-play-circle-line"></i>
              浏览精彩内容
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-6 md:gap-10">
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-background-50">5000万+</div>
              <div className="text-xs text-background-50/60 mt-1">注册用户</div>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-accent-400">10万+</div>
              <div className="text-xs text-background-50/60 mt-1">每日更新</div>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-background-50">2亿+</div>
              <div className="text-xs text-background-50/60 mt-1">累计下载</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}